// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Settings_pageName__kWDfm"};